import { render, staticRenderFns } from "./ErrorMessageComponent.vue?vue&type=template&id=64034d83&"
import script from "./ErrorMessageComponent.vue?vue&type=script&lang=js&"
export * from "./ErrorMessageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports